function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinejoin: "round",
  strokeWidth: 1.093
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.186 14.04c-3.372 0-6.07 3.081-6.07 6.937 0 2.128.828 4.05 2.136 5.324a29.166 29.166 0 012.51-2.512 3.598 3.598 0 01-1.648-3.037 3.59 3.59 0 013.596-3.6h26.374a3.59 3.59 0 013.597 3.6 3.598 3.598 0 01-1.648 3.037 29.16 29.16 0 012.51 2.512c1.308-1.275 2.135-3.196 2.135-5.324 0-3.856-2.697-6.937-6.07-6.937z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.711 17.14a3.59 3.59 0 00-3.596 3.6c0 1.275.653 2.398 1.648 3.037-4.419 3.878-7.315 8.85-8.242 12.56-2.997 11.999 5.147 18.599 23.377 18.599s26.374-6.6 23.377-18.598c-.927-3.71-3.823-8.683-8.242-12.561a3.598 3.598 0 001.648-3.038 3.59 3.59 0 00-3.596-3.599zM25.788 3.43a3.001 3.001 0 00-.075 6c.492.749.981 1.324 1.498 1.874.602-.407 1.172-.84 1.686-1.35a7.713 7.713 0 01-1.086-1.312 3.042 3.042 0 00.974-2.212c0-1.657-1.342-3-2.997-3zm4.795 7.874c-.5.532-1.044 1.043-1.685 1.5.555.395 1.168.783 1.91 1.2h4.196c-1.296-.908-2.936-1.695-4.42-2.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.007 3.43a2.998 2.998 0 00-2.997 3c0 .867.386 1.664.974 2.212-1.7 2.659-4.964 3.8-7.193 5.362h4.196c2.486-1.394 3.715-2.472 5.095-4.575a3.001 3.001 0 00-.075-5.999z"
}));

var SvgPurse = function SvgPurse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPurse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Purse.fb91d78d.svg";
export { ForwardRef as ReactComponent };